import {
  CLEAN_CONNECTIVITY_RESPONSES,
  CLEAR_NOVEDADES_CONECTIVIDAD,
  CLEAR_PROVIDERS_RESPONSES,
  CLEAR_WSMLART_XML_PREVIEW,
  GET_ALL_CONNECTIVITY_ERRORS,
  GET_ALL_CONNECTIVITY_ERRORS_NOT_PROCESSED,
  GET_CONNECTIVITY_ERRORS,
  GET_CONNECTIVITY_RESPONSES,
  GET_NOVEDADES_CONECTIVIDAD,
  GET_PROVIDERS_RESPONSES,
  GET_SEARCH_CONNECTIVITY_RESPONSES,
  GET_WSMLART_XML_PREVIEW,
  POST_WSMLART_NOVEDADES,
  RESEND_PROVIDERS_RESPONSES,
  SET_TIME,
  UPDATE_PROVIDERS_RESPONSES
} from "../actions/connectivityResponse";

const INITIAL_STATE = {
  connectivityErrors: {
    isFetching: false,
    didInvalidate: false,
    data: [],
    time: 2,
  },
  allConnectivityErrors: {
    isFetching: false,
    wsmlartXmlPreview: {
      isFetching: false,
      didInvalidate: false,
      data: null,
    },
    didInvalidate: false,
    data: [],
  },
  allConnectivityErrorsNotProcessed: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  searchConnectivityResponses: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  connectivityNews: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  newsResponses: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  postWSMLARTNovedades: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  providersResponses: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
};

const connectivityResponse = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_SEARCH_CONNECTIVITY_RESPONSES}_FULFILLED`:
      return {
        ...state,
        searchConnectivityResponses: {
          ...state.searchConnectivityResponses,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_SEARCH_CONNECTIVITY_RESPONSES}_REJECTED`:
      return {
        ...state,
        searchConnectivityResponses: {
          ...state.searchConnectivityResponses,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_SEARCH_CONNECTIVITY_RESPONSES}_PENDING`:
      return {
        ...state,
        searchConnectivityResponses: {
          ...state.searchConnectivityResponses,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${POST_WSMLART_NOVEDADES}_FULFILLED`:
      return {
        ...state,
        postWSMLARTNovedades: {
          ...state.postWSMLARTNovedades,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${POST_WSMLART_NOVEDADES}_REJECTED`:
      return {
        ...state,
        postWSMLARTNovedades: {
          ...state.postWSMLARTNovedades,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${POST_WSMLART_NOVEDADES}_PENDING`:
      return {
        ...state,
        postWSMLARTNovedades: {
          ...state.postWSMLARTNovedades,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_NOVEDADES_CONECTIVIDAD}_FULFILLED`:
      return {
        ...state,
        connectivityNews: {
          ...state.connectivityNews,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_NOVEDADES_CONECTIVIDAD}_REJECTED`:
      return {
        ...state,
        connectivityNews: {
          ...state.connectivityNews,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_NOVEDADES_CONECTIVIDAD}_PENDING`:
      return {
        ...state,
        connectivityNews: {
          ...state.connectivityNews,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case CLEAR_NOVEDADES_CONECTIVIDAD:
      return {
        ...state,
        connectivityNews: INITIAL_STATE.connectivityNews,
      };
    case `${GET_CONNECTIVITY_ERRORS}_FULFILLED`:
      return {
        ...state,
        connectivityErrors: {
          ...state.connectivityErrors,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_CONNECTIVITY_ERRORS}_REJECTED`:
      return {
        ...state,
        connectivityErrors: {
          ...state.connectivityErrors,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_CONNECTIVITY_ERRORS}_PENDING`:
      return {
        ...state,
        connectivityErrors: {
          ...state.connectivityErrors,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_ALL_CONNECTIVITY_ERRORS}_FULFILLED`:
      return {
        ...state,
        allConnectivityErrors: {
          ...state.allConnectivityErrors,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_ALL_CONNECTIVITY_ERRORS}_REJECTED`:
      return {
        ...state,
        allConnectivityErrors: {
          ...state.allConnectivityErrors,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_ALL_CONNECTIVITY_ERRORS}_PENDING`:
      return {
        ...state,
        allConnectivityErrors: {
          ...state.allConnectivityErrors,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_ALL_CONNECTIVITY_ERRORS_NOT_PROCESSED}_FULFILLED`:
      return {
        ...state,
        allConnectivityErrorsNotProcessed: {
          ...state.allConnectivityErrorsNotProcessed,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_ALL_CONNECTIVITY_ERRORS_NOT_PROCESSED}_REJECTED`:
      return {
        ...state,
        allConnectivityErrorsNotProcessed: {
          ...state.allConnectivityErrorsNotProcessed,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_ALL_CONNECTIVITY_ERRORS_NOT_PROCESSED}_PENDING`:
      return {
        ...state,
        allConnectivityErrorsNotProcessed: {
          ...state.allConnectivityErrorsNotProcessed,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_CONNECTIVITY_RESPONSES}_FULFILLED`:
      return {
        ...state,
        searchConnectivityResponses: {
          ...state.searchConnectivityResponses,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_CONNECTIVITY_RESPONSES}_REJECTED`:
      return {
        ...state,
        searchConnectivityResponses: {
          ...state.searchConnectivityResponses,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_CONNECTIVITY_RESPONSES}_PENDING`:
      return {
        ...state,
        searchConnectivityResponses: {
          ...state.searchConnectivityResponses,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CLEAN_CONNECTIVITY_RESPONSES}`:
      return {
        ...state,
        searchConnectivityResponses: INITIAL_STATE.searchConnectivityResponses,
      };
    case `${SET_TIME}`:
      return {
        ...state,
        connectivityErrors: {
          ...state.connectivityErrors,
          time: action.payload,
        },
      };
    case `${GET_PROVIDERS_RESPONSES}_FULFILLED`:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_PROVIDERS_RESPONSES}_REJECTED`:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PROVIDERS_RESPONSES}_PENDING`:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${RESEND_PROVIDERS_RESPONSES}_FULFILLED`:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: false,
          didInvalidate: false,
        },
      };
    case `${RESEND_PROVIDERS_RESPONSES}_REJECTED`:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${RESEND_PROVIDERS_RESPONSES}_PENDING`:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case CLEAR_PROVIDERS_RESPONSES:
      return {
        ...state,
        providersResponses: INITIAL_STATE.providersResponses,
      };
    case `${GET_WSMLART_XML_PREVIEW}_FULFILLED`:
      return {
        ...state,
        wsmlartXmlPreview: {
          ...state.wsmlartXmlPreview,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_WSMLART_XML_PREVIEW}_REJECTED`:
      return {
        ...state,
        wsmlartXmlPreview: {
          ...state.wsmlartXmlPreview,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_WSMLART_XML_PREVIEW}_PENDING`:
      return {
        ...state,
        wsmlartXmlPreview: {
          ...state.wsmlartXmlPreview,
          isFetching: true,
          didInvalidate: false,
          data: null,
        },
      };
    case CLEAR_WSMLART_XML_PREVIEW:
      return {
        ...state,
        wsmlartXmlPreview: INITIAL_STATE.wsmlartXmlPreview,
      };
    case UPDATE_PROVIDERS_RESPONSES:
      return {
        ...state,
        providersResponses: {
          ...state.providersResponses,
          isFetching: false,
          didInvalidate: false,
          data: state.providersResponses.data.map(item => {
            const isUpdated = action.payload.some(id => String(id) === String(item.idRespuesta));
            if (isUpdated) {
              return {
                ...item,
                recepcionConfirmada: false,
                fechaHoraConfirmada: null,
              };
            }
            return item;
          })
        }
      };
    default:
      return state;
  }
};

export default connectivityResponse;
